/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsConfigAHBResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsConfigAHBResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsConfigAHBResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsConfigAHBResource>): RecommendationForFinopsConfigAHBResource {
        let obj = Object.assign(new RecommendationForFinopsConfigAHBResource(), model);
        RecommendationForFinopsConfigAHBResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsConfigAHBResource>): RecommendationForFinopsConfigAHBResource {
        if (!model) return null;
        return RecommendationForFinopsConfigAHBResource.newInstance(<RecommendationForFinopsConfigAHBResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsConfigAHBResource) {
        if (!obj) return;

        models.RecommendationForFinopsConfigAHBResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsConfigAHBResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsConfigAHBResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
